import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../../../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_a4cbdbf0 from 'nuxt_plugin_plugin_a4cbdbf0' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_plugin_9944a234 from 'nuxt_plugin_plugin_9944a234' // Source: ./vuetify/plugin.js (mode: 'all')
import nuxt_plugin_workbox_7bb3aeba from 'nuxt_plugin_workbox_7bb3aeba' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_17379bcd from 'nuxt_plugin_metaplugin_17379bcd' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_iconplugin_1bdf4141 from 'nuxt_plugin_iconplugin_1bdf4141' // Source: ./pwa/icon.plugin.js (mode: 'all')
import nuxt_plugin_axios_7601091e from 'nuxt_plugin_axios_7601091e' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_aosclient_11b8a426 from 'nuxt_plugin_aosclient_11b8a426' // Source: ../../../plugins/aos.client.js (mode: 'client')
import nuxt_plugin_headutil_11cbc384 from 'nuxt_plugin_headutil_11cbc384' // Source: ../../../plugins/head-util.js (mode: 'all')
import nuxt_plugin_pwaupdate_81602bf6 from 'nuxt_plugin_pwaupdate_81602bf6' // Source: ../../../plugins/pwa-update.js (mode: 'client')
import nuxt_plugin_owlcarousel_6240c198 from 'nuxt_plugin_owlcarousel_6240c198' // Source: ../../../plugins/owl-carousel.js (mode: 'client')
import nuxt_plugin_wow_2d4c4024 from 'nuxt_plugin_wow_2d4c4024' // Source: ../../../plugins/wow.js (mode: 'client')
import nuxt_plugin_i18n_1fba523a from 'nuxt_plugin_i18n_1fba523a' // Source: ../../../plugins/i18n.js (mode: 'all')
import nuxt_plugin_vuecookies_6b36a0a5 from 'nuxt_plugin_vuecookies_6b36a0a5' // Source: ../../../plugins/vue-cookies.js (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"etax | e-Tax Invoice มาตรฐานกรมสรรพากร | service provider บริการออกใบกำกับภาษี และใบรับเงินอิเล็กทรอนิกส์","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"name":"format-detection","content":"telephone=no"},{"name":"google-adsense-account","content":"ca-pub-4044321130546891"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.png"},{"rel":"dns-prefetch","href":"https:\u002F\u002Ffonts.googleapis.com"},{"rel":"dns-prefetch","href":"https:\u002F\u002Ffonts.gstatic.com","crossorigin":true},{"rel":"dns-prefetch","href":"https:\u002F\u002Fcdn.jsdelivr.net"},{"rel":"dns-prefetch","href":"https:\u002F\u002Fcode.jquery.com"},{"rel":"stylesheet","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Kanit:wght@100;300;400;500;700&display=swap"},{"rel":"stylesheet","href":"https:\u002F\u002Fcdn.jsdelivr.net\u002Fnpm\u002Fbootstrap@5.2.3\u002Fdist\u002Fcss\u002Fbootstrap.min.css"},{"rel":"stylesheet","href":"https:\u002F\u002Fcdn.jsdelivr.net\u002Fgh\u002Flipis\u002Fflag-icons@7.0.0\u002Fcss\u002Fflag-icons.min.css"},{"rel":"stylesheet","type":"text\u002Fcss","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss?family=Roboto:100,300,400,500,700,900&display=swap"},{"rel":"stylesheet","type":"text\u002Fcss","href":"https:\u002F\u002Fcdn.jsdelivr.net\u002Fnpm\u002F@mdi\u002Ffont@latest\u002Fcss\u002Fmaterialdesignicons.min.css"}],"__dangerouslyDisableSanitizers":["script"],"script":[{"src":"https:\u002F\u002Fcdn.jsdelivr.net\u002Fnpm\u002Fbootstrap@5.2.3\u002Fdist\u002Fjs\u002Fbootstrap.bundle.min.js","type":"text\u002Fjavascript"},{"src":"https:\u002F\u002Fcode.jquery.com\u002Fjquery-3.7.1.min.js","type":"text\u002Fjavascript"},{"hid":"gtm-1","src":"https:\u002F\u002Fwww.googletagmanager.com\u002Fgtag\u002Fjs?id=G-QV0E4VXJ70","defer":true},{"hid":"gtm-2","innerHTML":"window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);} gtag('js', new Date()); gtag('config', 'G-QV0E4VXJ70');","type":"text\u002Fjavascript","charset":"utf-8"},{"hid":"gtm-3","src":"https:\u002F\u002Fwww.googletagmanager.com\u002Fgtag\u002Fjs?id=GT-WPL82VB","defer":true},{"hid":"gtm-4","innerHTML":"window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);} gtag('js', new Date()); gtag('config', 'GT-WPL82VB');","type":"text\u002Fjavascript","charset":"utf-8"},{"hid":"gtm-5","innerHTML":"(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\n      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\n      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n      'https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n      })(window,document,'script','dataLayer','GTM-WZ3FJX6');","type":"text\u002Fjavascript","charset":"utf-8"},{"type":"text\u002Fjavascript","src":"https:\u002F\u002Fcookiecdn.com\u002Fcwc.js"},{"type":"text\u002Fjavascript","src":"https:\u002F\u002Fcookiecdn.com\u002Fcwc.js"}],"style":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      errPageReady: false,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        nuxt.errPageReady = false
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_a4cbdbf0 === 'function') {
    await nuxt_plugin_plugin_a4cbdbf0(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_9944a234 === 'function') {
    await nuxt_plugin_plugin_9944a234(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_7bb3aeba === 'function') {
    await nuxt_plugin_workbox_7bb3aeba(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_17379bcd === 'function') {
    await nuxt_plugin_metaplugin_17379bcd(app.context, inject)
  }

  if (typeof nuxt_plugin_iconplugin_1bdf4141 === 'function') {
    await nuxt_plugin_iconplugin_1bdf4141(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_7601091e === 'function') {
    await nuxt_plugin_axios_7601091e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_aosclient_11b8a426 === 'function') {
    await nuxt_plugin_aosclient_11b8a426(app.context, inject)
  }

  if (typeof nuxt_plugin_headutil_11cbc384 === 'function') {
    await nuxt_plugin_headutil_11cbc384(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_pwaupdate_81602bf6 === 'function') {
    await nuxt_plugin_pwaupdate_81602bf6(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_owlcarousel_6240c198 === 'function') {
    await nuxt_plugin_owlcarousel_6240c198(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_wow_2d4c4024 === 'function') {
    await nuxt_plugin_wow_2d4c4024(app.context, inject)
  }

  if (typeof nuxt_plugin_i18n_1fba523a === 'function') {
    await nuxt_plugin_i18n_1fba523a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuecookies_6b36a0a5 === 'function') {
    await nuxt_plugin_vuecookies_6b36a0a5(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
